import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import VideoPlayerCore from "./VideoPlayerCore";

var VideoPlayer = function VideoPlayer(_ref) {
  var description = _ref.description,
      duration = _ref.duration,
      name = _ref.name,
      thumbnailUrl = _ref.thumbnailUrl,
      uploadDate = _ref.uploadDate,
      videoProps = _objectWithoutProperties(_ref, ["description", "duration", "name", "thumbnailUrl", "uploadDate"]);

  var getClassName = getClassNameFactory(VideoPlayer.displayName);
  var jsonLd = (description || duration || name || thumbnailUrl || uploadDate) && {
    "@context": "http://schema.org",
    "@type": "VideoObject",
    description: description,
    duration: duration,
    name: name,
    thumbnailUrl: thumbnailUrl,
    uploadDate: uploadDate
  };
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, jsonLd && /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify(jsonLd)), /*#__PURE__*/React.createElement(VideoPlayerCore, _extends({
    duration: duration
  }, videoProps)));
};

VideoPlayer.displayName = "VideoPlayer";
export default VideoPlayer;